import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createTextVNode as _createTextVNode, withCtx as _withCtx, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = { class: "pagination-wrapper uk-flex uk-flex-between uk-flex-middle uk-margin-small-bottom" }
const _hoisted_2 = {
  key: 0,
  "uk-spinner": "ratio: 1"
}
const _hoisted_3 = { class: "node-wrapper uk-flex" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["uk-icon"]
const _hoisted_6 = ["onClick"]
const _hoisted_7 = ["uk-icon"]
const _hoisted_8 = {
  key: 3,
  class: "node-name"
}
const _hoisted_9 = ["onClick"]
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_variable_buttons_row = _resolveComponent("variable-buttons-row")!
  const _component_per_page_selector = _resolveComponent("per-page-selector")!
  const _component_the_pagination = _resolveComponent("the-pagination")!
  const _component_image_variable_icon = _resolveComponent("image-variable-icon")!
  const _component_folder_name_input = _resolveComponent("folder-name-input")!
  const _component_draggable = _resolveComponent("draggable")!
  const _component_variables_tree_renderless = _resolveComponent("variables-tree-renderless")!

  return (_openBlock(), _createBlock(_component_variables_tree_renderless, {
    type: _ctx.type,
    "edit-mode-allowed": _ctx.editModeAllowed,
    onVariableClicked: _ctx.variableClickedHandler
  }, {
    default: _withCtx(({
      editMode,
      treeData,
      isNodeRemoveable,
      createFolderHandler,
      updateFolderNameHandler,
      removeFolder,
      handleEditClick,
      isCurrentEditFolder,
      setCurrentEditFolder,
      nodeClickedHandler,
      dropChangeHandler,
      searchTriggeredHandler,
      childrenLoadHandler
    }) => [
      _createElementVNode("div", _mergeProps(_ctx.$attrs, {
        id: "items-tree-container",
        class: "uk-padding-small"
      }), [
        _createVNode(_component_variable_buttons_row, {
          "edit-mode-allowed": _ctx.editModeAllowed,
          "edit-mode": editMode,
          onCreateFolderClicked: ($event: any) => (_ctx.createFolderWrapperHandler(createFolderHandler)),
          onSwitchEditModeClicked: handleEditClick,
          onSearchTriggered: searchTriggeredHandler
        }, null, 8, ["edit-mode-allowed", "edit-mode", "onCreateFolderClicked", "onSwitchEditModeClicked", "onSearchTriggered"]),
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_per_page_selector, {
            "page-options": _ctx.perPageOptions,
            onSelected: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('paginate')))
          }, null, 8, ["page-options"]),
          (_ctx.totalCount && _ctx.totalCount > 0)
            ? (_openBlock(), _createBlock(_component_the_pagination, {
                key: 0,
                "max-pages-shown": 5,
                "prev-button-content": "<",
                "next-button-content": ">",
                class: "uk-margin-remove-vertical",
                onInputChanged: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('paginate')))
              }))
            : _createCommentVNode("", true)
        ]),
        (_ctx.loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2))
          : (treeData.length > 0)
            ? (_openBlock(), _createBlock(_component_draggable, {
                key: 1,
                "tree-data": treeData,
                draggable: editMode,
                gap: 7,
                "children-lazy-loading": "",
                "children-loader": childrenLoadHandler,
                virtualization: "",
                class: "variables-tree items-tree uk-padding-small",
                onDropChange: dropChangeHandler
              }, {
                default: _withCtx(({ node, tree, index }) => [
                  _createElementVNode("div", _hoisted_3, [
                    (node.folder)
                      ? (_openBlock(), _createElementBlock("b", {
                          key: 0,
                          class: "node-toggle",
                          onClick: ($event: any) => (tree.toggleFold(node))
                        }, [
                          _createElementVNode("span", {
                            "uk-icon": `icon: ${
                  node.$folded ? 'plus' : 'minus'
                }; ratio: 0.4`
                          }, null, 8, _hoisted_5)
                        ], 8, _hoisted_4))
                      : _createCommentVNode("", true),
                    _createElementVNode("span", {
                      class: _normalizeClass(_ctx.variableNodeClasses(node)),
                      onClick: ($event: any) => (nodeClickedHandler(tree, node))
                    }, [
                      (_ctx.isImageVariableNode(node))
                        ? (_openBlock(), _createBlock(_component_image_variable_icon, {
                            key: 0,
                            name: node.name,
                            "img-url": node.thumbUrl,
                            class: "uk-margin-small-right"
                          }, null, 8, ["name", "img-url"]))
                        : (_openBlock(), _createElementBlock("span", {
                            key: 1,
                            class: _normalizeClass(["uk-margin-small-right", _ctx.nodeIconClasses(node)]),
                            "uk-icon": _ctx.nodeIconAttrs(node)
                          }, null, 10, _hoisted_7)),
                      (node.folder && editMode && isCurrentEditFolder(node.id))
                        ? (_openBlock(), _createBlock(_component_folder_name_input, {
                            key: 2,
                            id: node.id,
                            name: node.name,
                            "external-index": index,
                            onSave: updateFolderNameHandler,
                            onCancel: ($event: any) => (setCurrentEditFolder(undefined))
                          }, null, 8, ["id", "name", "external-index", "onSave", "onCancel"]))
                        : (_openBlock(), _createElementBlock("span", _hoisted_8, [
                            _createTextVNode(_toDisplayString(node.name) + " ", 1),
                            (isNodeRemoveable(node))
                              ? (_openBlock(), _createElementBlock("span", {
                                  key: 0,
                                  "uk-icon": "icon: close; ratio: 0.8;",
                                  class: "remove-folder-button",
                                  onClick: _withModifiers(($event: any) => (_ctx.removeFolderHandler(removeFolder, node)), ["stop"])
                                }, null, 8, _hoisted_9))
                              : _createCommentVNode("", true),
                            (
                    node.folder && editMode && !isCurrentEditFolder(node.id)
                  )
                              ? (_openBlock(), _createElementBlock("span", {
                                  key: 1,
                                  "uk-icon": "icon: pencil; ratio: 0.8;",
                                  class: "edit-folder-name-button uk-margin-small-right",
                                  onClick: _withModifiers(($event: any) => (setCurrentEditFolder(node.id)), ["stop"])
                                }, null, 8, _hoisted_10))
                              : _createCommentVNode("", true)
                          ]))
                    ], 10, _hoisted_6)
                  ])
                ]),
                _: 2
              }, 1032, ["tree-data", "draggable", "children-loader", "onDropChange"]))
            : (_openBlock(), _createElementBlock("p", _hoisted_11, _toDisplayString(_ctx.$t('shared.no_data')), 1))
      ], 16)
    ]),
    _: 1
  }, 8, ["type", "edit-mode-allowed", "onVariableClicked"]))
}